export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5483.844bafc2.jpg";